import { createSlice } from '@reduxjs/toolkit';

const photoGallerySlice = createSlice({
  name: 'photoGallery',
  initialState: { albums: [], loaded: false },
  reducers: {
    setAlbums: (state, action) => { state.albums = action.payload; state.loaded = true; },
  },
});

export const { setAlbums } = photoGallerySlice.actions;
export default photoGallerySlice;
